export { ArrowsExpand as default } from './ArrowsExpand';
